import React, { useMemo } from 'react';

import { IonButton } from '@ionic/react';

import useLocalStorageState from 'hooks/useLocalStorageState';

import Logo from '../Logo';
import { oktaAuth } from '../okta';
import { oktaInstances } from '../okta';

const LoginPage: React.FC = () => {
  const [storageOktaProvider, setStorageOktaProvider] =
    useLocalStorageState('oktaProvider');

  const oktaProvider = useMemo(() => {
    if (!storageOktaProvider) {
      setStorageOktaProvider(process.env.REACT_APP_OKTA_DOMAIN);
      return process.env.REACT_APP_OKTA_DOMAIN;
    }
    return storageOktaProvider;
  }, [storageOktaProvider, setStorageOktaProvider]);

  const switchToOtherOktaProvider = useMemo(() => {
    if (oktaInstances.length === 2) {
      if (storageOktaProvider) {
        return oktaInstances?.find(item => item.domain !== oktaProvider);
      }
      return oktaInstances.at(-1);
    }
    return null;
  }, []);
  const handleSwitchToOtherOktaProvider = () => {
    if (switchToOtherOktaProvider) {
      setStorageOktaProvider(switchToOtherOktaProvider?.domain);
      window.location.reload();
    }
  };

  const handleLogin = async () => {
    await oktaAuth.signInWithRedirect({
      originalUri: window.location.origin,
    });
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '16px',
        }}
      >
        {switchToOtherOktaProvider ? (
          <IonButton fill={'clear'} onClick={handleSwitchToOtherOktaProvider}>
            Switch to {switchToOtherOktaProvider?.name}
          </IonButton>
        ) : null}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: 'calc(100vh - 64px)',
        }}
      >
        <div
          style={{
            height: '120px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Logo />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IonButton onClick={handleLogin}>Login with okta</IonButton>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
